import { ArticleData } from "@/sanity/interfaces";
import imageUrl from "@/sanity/utilities/imageUrl";

export const mapArticleInfo = (
  items: ArticleData[],
  articleUrlText?: string,
) => {
  try {
    return items.map((item) => {
      const { category, estimatedReadMins, heroImage, seo, slug, title } = item;

      return {
        articleUrl: slug?.current ? `/learn/${slug.current}` : "",
        articleUrlText: articleUrlText ?? "Read More",
        category: category?.title,
        description: seo?.description ?? "",
        imageUrl: heroImage?.asset
          ? imageUrl(heroImage?.asset).url()
          : undefined,
        readMinutes: estimatedReadMins,
        title,
        updatedDate: item?.modifiedAt ?? item._updatedAt ?? item?.publishedAt,
      };
    });
  } catch (error) {
    console.error("Error mapping article info:", error);
    return [];
  }
};
